import { api } from '../../client';
import type { EmployeeLeaveCreditDto } from '../hr/employees';

export const employeeLeaveCreditsApi = {
  async list(): Promise<{ data?: EmployeeLeaveCreditDto[]; message?: string }> {
    return api.get('/employee/leave-credits') as Promise<{ data: EmployeeLeaveCreditDto[] }>;
  },
};
